import { ZipCodeValidation } from '../../../../shared/Form';

export class ZipCodeValidationDK extends ZipCodeValidation {
  constructor(errorMessage: string = 'Entered value is not a valid zip code.') {
    super(/^[1-9]{1}[0-9]{3}$/i, errorMessage);
  }
}
